import { useMemo } from "react"
import CopyToClipboard from "react-copy-to-clipboard"
import { Heading } from "./Heading"
import Prism from "prismjs/components/prism-core"
import "prismjs/components/prism-clike"
import "prismjs/components/prism-markup"
import "prismjs/components/prism-css"
import "prismjs/components/prism-javascript"

interface Props {
  title?: string
  copy?: boolean
  lang: string
  content: string
  headingLevel?: number
}

export const Code = ({
  title,
  copy = false,
  lang,
  content,
  headingLevel = 3,
}: Props) => {
  const html = useMemo(
    () => Prism.highlight(content.trim(), Prism.languages[lang], lang),
    [content, lang]
  )

  return (
    <article className="code-block relative mt-6">
      <header className="absolute inset-x-0 top-0 flex items-end justify-between flex-row rounded-t border-b border-neutral-200 py-2 px-3">
        <Heading
          level={headingLevel}
          className="font-mono text-sm font-normal m-0"
        >
          {lang} {title && `: ${title}`}
        </Heading>
        {copy && (
          <CopyToClipboard text={content}>
            <button className="btn btn--small">Copy</button>
          </CopyToClipboard>
        )}
      </header>

      <pre className="mt-0 p-4 pt-12">
        <code
          className={`language-${lang}`}
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </pre>
    </article>
  )
}
